module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./ThematicView.js"));
	}, "ThematicView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ThematicView!./src/pages/Learn/Thematic/ThematicView.js
// module id = 2160
// module chunks = 367